import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Spinner } from '@/components/ui/spinner';
import i18n from '@/utils/i18n';

interface ReplacementShipmentDialogProps {
  open: boolean;
  loading: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

/**
 * Confirms creating a replacement Sendcloud shipment for an order the carrier
 * returned. Deliberately spells out the cost: the mutation buys a new parcel
 * set, and the previous one was already paid for.
 */
export function ReplacementShipmentDialog({
  open,
  loading,
  onOpenChange,
  onConfirm,
}: ReplacementShipmentDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{i18n.t('Order:replacementShipmentTitle')}</DialogTitle>
          <DialogDescription>
            {i18n.t('Order:replacementShipmentDescription')}
          </DialogDescription>
        </DialogHeader>
        <DialogBody>
          <p className="tw:text-sm tw:text-muted-foreground">
            {i18n.t('Order:replacementShipmentCostWarning')}
          </p>
        </DialogBody>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline" disabled={loading}>
              {i18n.t('Common:cancel')}
            </Button>
          </DialogClose>
          <Button onClick={onConfirm} disabled={loading}>
            {loading && <Spinner className="tw:mr-2 tw:size-4" />}
            {i18n.t('Order:replacementShipmentConfirm')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
